import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckBranchDeltas } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_DELTAS } from '@constants/queryKeys';

const useQueryConsistencyCheckDeltas = (comparisonId: string) => {
	const {
		data: deltasOptions,
		isLoading: isLoadingDeltasOptions,
		isFetching: isFetchingDeltasOptions,
	} = useQuery<TNameTitle[], TSelectOption[]>({
		queryKey: [CONSISTENCY_DELTAS, comparisonId],
		queryFn: extractQueryParams(getConsistencyCheckBranchDeltas),
		select: (options) => optionsFormatted(options || []),
		enabled: [comparisonId],
		...refetchOptions,
	});

	return {
		deltasOptions: deltasOptions || [],
		isLoadingDatesOptions: (isLoadingDeltasOptions && !!deltasOptions)
			|| isFetchingDeltasOptions,
	};
};

export default useQueryConsistencyCheckDeltas;
